// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3bdDr","empty":"ModalGraph_empty__3hLIi"};